import { CalendarEvent, CommonEventValidation, CreateEvent, EditEvent, ScheduleEvent } from 'src/types/Events';

export function getNewEvent(): CreateEvent {
  return {
    id: '',
    visit_type: '',
    sub_type: '',
    start_date: '',
    end_date: '',
    created_by: ''
  };
}

export function getEditEvent(eventToBeEdited: ScheduleEvent | null): EditEvent {
  if (eventToBeEdited) {
    return {
      id: eventToBeEdited.id,
      visit_type: eventToBeEdited.visit_type,
      sub_type: eventToBeEdited.sub_type,
      start_date: eventToBeEdited.start_date,
      end_date: eventToBeEdited.end_date,
      updated_by: ''
    };
  } else {
    return {
      id: '0',
      visit_type: '',
      sub_type: '',
      start_date: '',
      end_date: '',
      updated_by: ''
    };
  }
}

export function getEventValidationReset(): CommonEventValidation {
  return {
    visit_type: false,
    sub_type: false,
    start_date: false,
    end_date: false
  };
}

export function getCalendarEvents(eventsData: ScheduleEvent[]): CalendarEvent[] {
  const allCalenderMEvents: CalendarEvent[] = eventsData.map((singleEvent: ScheduleEvent) => {
    return {
      ...singleEvent,
      start_date: `${singleEvent.start_date}Z`,
      end_date: `${singleEvent.end_date}Z`,
      start: new Date(`${singleEvent.start_date}Z`),
      end: new Date(`${singleEvent.end_date}Z`),
      title:
        singleEvent.visit_type === 'Interim Monitoring Visit' ||
        singleEvent.visit_type === 'Site Qualification Visit' ||
        singleEvent.visit_type === 'Site Initiation Visit'
          ? singleEvent.visit_type
          : singleEvent.visit_name
    };
  });
  return allCalenderMEvents;
}
